export default ({ store, redirect }) => {
  if (!store.state.userSubscriptions.userHasVisualMappingSubscription) {
    redirect(
      REDIRECT_URLS.UPGRADE_SUBSCRIPTION_PLACEHOLDER /*eslint-disable-line no-undef */
    )
  }
}
